<template>
  <v-dialog v-model="dialog" width="700">
    <template v-slot:activator="{ on }">
      <v-btn
        title="Éditer la candidature"
        class="mx-2 primary"
        v-on="on"
        small
        rounded
      >
        <v-icon small color="white">mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid">
      <v-alert v-if="error.messages" border="left" type="error" elevation="2">
        <template v-for="(errorMessage, index) in error.messages">
          <span :key="index">
            {{ errorMessage }}
            <br />
          </span>
        </template>
      </v-alert>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Reset état candidature
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              candidature à la formation :
              <span class="elevation-5">{{
                candidature.libelleFormation
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              état actuel de la demande :
              <span class="elevation-5">{{
                candidature.etatDemande.libelle
              }}</span>
            </v-col>
          </v-row>
          <v-row v-if="etatsReset && etatsReset.length > 0">
            <v-col cols="12">
              <v-select
                v-model="etatToReset.etat"
                label="Reset à l'état *"
                :items="etatsReset"
                item-value="id"
                item-text="libelle"
                return-object
                :rules="etatResetRule"
                @change="etatToReset.dateReset = null"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" md="12">
              <v-chip class="ma-2"
                >Pas de reset possible<span
                  v-if="commentaire"
                  class="font-weight-bold"
                >
                  : {{ commentaire }}</span
                ></v-chip
              >
            </v-col>
          </v-row>

          <v-menu
            v-if="etatToReset.etat && isDateRequise(etatToReset.etat.id)"
            v-model="showCalendar"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formatedDate"
                :label="labelDate"
                prepend-icon="event"
                readonly
                clearable
                v-on="on"
                autofocus
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="fr-fr"
              :min="minDate"
              :max="maxDate"
              v-model="etatToReset.dateReset"
              @input="showCalendar = false"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-center">
            <v-btn
              v-if="etatsReset && etatsReset.length > 0"
              :disabled="!valid"
              :loading="loading"
              class="mx-2 primary"
              @click="valider"
            >
              <v-icon left>save</v-icon>
              Valider
            </v-btn>
            <v-btn class="mx-2 normal" @click="fermer">
              <v-icon left>mdi-close</v-icon>
              <span v-if="etatsReset && etatsReset.length > 0">Annuler</span>
              <span v-else>Fermer</span>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import BaseForm from "@/components/base/BaseForm";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import moment from "moment";
import { EtatDemande } from "@/mixins/EtatDemande.js";

export default {
  name: "FormDialogResetCandidature",
  extends: BaseForm,
  props: {
    candidature: { type: Object, required: true }
  },
  mixins: [EtatDemande],

  data() {
    return {
      dialog: false,
      loading: false,
      commentaire: "",
      etatsReset: [],
      etatToReset: {
        etat: null,
        dateReset: null
      },
      valid: false,
      showCalendar: false,
      etatResetRule: [v => !!v || "Veuillez sélectionner l'état de reset"],
      dateRules: [v => !!v || "La date est requise"]
    };
  },
  async created() {
    if (this.candidature.id) {
      await this.getEtatsResetCandidature(this.candidature.id);
    }
  },
  computed: {
    formatedDate: {
      get() {
        return this.etatToReset.dateReset
          ? moment(this.etatToReset.dateReset).format("DD/MM/YYYY")
          : "";
      },
      set(value) {
        this.etatToReset.dateReset = value;
      }
    },
    minDate() {
      return this.candidature.dateDepot
        ? moment(this.candidature.dateDepot, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";
    },
    maxDate() {
      return moment().format("YYYY-MM-DD");
    },
    labelDate() {
      return this.etatToReset.etat.id
        ? this.ETAT.TRAITEMENT_PEDAGOGIQUE.code || this.ETAT.RECTIFICATION.code
          ? "Date validation SUAIO *"
          : "Date"
        : "";
    }
  },
  methods: {
    async getEtatsResetCandidature(id) {
      this.loading = true;
      try {
        const reset = await ApiCandidatureRepository.getEtatsResetCandidature(
          id
        );
        this.commentaire = reset.commentaire;
        this.etatsReset = reset.etatsReset;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loading = false;
      }
    },
    async resetCandidature() {
      this.loading = true;
      try {
        await ApiCandidatureRepository.resetCandidature(
          this.candidature.id,
          this.etatToReset
        );
        await this.getEtatsResetCandidature(this.candidature.id);
        this.$emit("majCandidature");
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loading = false;
      }
    },
    fermer() {
      this.dialog = false;
      this.etatToReset.etat = null;
    },
    async valider() {
      await this.resetCandidature();
      this.fermer();
    },
    isDateRequise(idEtat) {
      if (
        idEtat == this.ETAT.TRAITEMENT_PEDAGOGIQUE.code ||
        idEtat == this.ETAT.RECTIFICATION.code
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
